//product-form.js
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement { 
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        const formData = new FormData(this.form);
        const mainVariantId = formData.get('id');
        const quantity = formData.get('quantity') || 1;

        // ===== ADDON LOGIC START =====
        // Use FIXED key for same product (so Shopify can merge quantities!)
        const uniqueKey = 'main_' + mainVariantId; // Based on variant ID, not timestamp!

        // Carry through any line-item properties rendered inside the product form.
        // Without this, fields like the gift-card recipient inputs
        // (properties[Recipient email], properties[Message], ...) are silently dropped.
        const mainProperties = {};
        for (const [field, value] of formData.entries()) {
          const match = field.match(/^properties\[(.+)\]$/);
          if (match && value !== '') mainProperties[match[1]] = value;
        }

        // Get selected addons
        const selectedAddons = window.getSelectedAddons ? window.getSelectedAddons() : [];

        // Only stamp the addon-tracking key when there are addons to link to it.
        // Stamping it unconditionally sends every cart line down cart.js's
        // removeMainProductWithAddons() path for no reason.
        if (selectedAddons.length) mainProperties['_main_product_key'] = uniqueKey;

        // Prepare items array
        const items = [{
          id: mainVariantId,
          quantity: parseInt(quantity),
          properties: mainProperties
        }];

        // Add each selected addon
        selectedAddons.forEach(addon => {
          items.push({
            id: addon.id,
            quantity: 1,
            properties: {
              '_addon_of': uniqueKey,
              'Add-on': 'Yes'
            }
          });
        });

        // Prepare sections
        let sections = '';
        let sections_url = '';
        
        if (this.cart) {
          sections = this.cart.getSectionsToRender().map((section) => section.id).join(',');
          sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }

        const body = JSON.stringify({
          items: items,
          sections: sections,
          sections_url: sections_url
        });

        config.body = body;
        // ===== ADDON LOGIC END =====

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: mainVariantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: mainVariantId,
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
